import React, {useState, useEffect} from "react"
import cx from 'classnames'

import styles from "./pa.module.scss"

const PersonalityAssessment = () => {
    
  const [assessmentLink, setAssessmentLink] = useState('https://personalityassessment.ca/surveys/13/67f133/show');

  useEffect(() => {
    const isLeadID = getCookie('leadID');
    if(isLeadID && isLeadID.length){
        setAssessmentLink(prev => prev + `?leadID=${isLeadID}&start=2`)
    }
  }, [])

  return (
    <section className={styles.pa}>
      <header className={styles.pa_header}>
        <h2>
          Personality <span className={styles.primary_color}>Assessment</span>
        </h2>
      </header>
      <div className={styles.pa_body}>
        <p>
          Find out what your personality is like and discover your traits,
          worries & concerns about taking the next step to study at school
          towards a new and rewarding career. This quick and easy assessment
          will provide you with some insight into what to focus on and what you
          might need to watch out for to best prepare you for your new career
          and school goals!
        </p>
        <button className={cx(styles.take_assesment, 'mover')}>
          <a href={assessmentLink} target="_blank">
            Take Assessment!
          </a>
        </button>
      </div>
    </section>
  )
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

export default PersonalityAssessment
